/**
 * /tenants/$slug/users/$userId — detail route shim.
 */

import { createFileRoute } from "@tanstack/react-router";
import { fetchUserDetail } from "@/features/users/queries";
import { queryKeys } from "@/lib/query-keys";
import { NotFoundError } from "@/lib/api-client";
import { UserDetailPage } from "@/features/users/pages/user-detail-page";
import { userDetailSearchSchema } from "@/features/users/schemas";

export const Route = createFileRoute("/_authed/tenants/$slug/users/$userId")({
  validateSearch: (raw: Record<string, unknown>) => userDetailSearchSchema.parse(raw),
  loader: async ({ context, params }) => {
    try {
      await context.queryClient.ensureQueryData({
        queryKey: queryKeys.users.detail(context.tenant.id, params.userId),
        queryFn: () => fetchUserDetail(context.tenant.id, params.userId),
      });
    } catch (err) {
      // Let 404s bubble to the router's notFoundComponent; rethrow
      // other errors so the error boundary catches them.
      if (err instanceof NotFoundError) throw err;
      throw err;
    }
  },
  component: UserDetailPage,
});
